import * as AngularAnimations from '@angular/animations';
import * as AngularAnimationsBrowser from '@angular/animations/browser';
import * as AngularCommon from '@angular/common';
import * as AngularCommonHttp from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import * as AngularCore from '@angular/core';
import { ComponentFactoryResolver, Injectable, Injector, NgModuleFactory } from '@angular/core';
import * as AngularForms from '@angular/forms';
import * as AngularPlatformBrowser from '@angular/platform-browser';
import * as AngularPlatformBrowserDynamic from '@angular/platform-browser-dynamic';
import * as AngularPlatformBrowserAnimations from '@angular/platform-browser/animations';
import * as AngularRouter from '@angular/router';
import * as UtilModule from '@gspwidget/util';
import { appendScript, BasicWidgetInfoAotMode, BasicWidgetInfoDevMode, WEB_PATH_HOME, WidgetContainerMode, WidgetRepo } from '@gspwidget/util';
// import * as PortletModule from '@gspwidget/widget-core';
// import * as WidgetCoreModule from '../public-api';
import * as WidgetDevkitModule from '@gspwidget/widget-devkit';
import { PropertyOption, RegisteredWidgetConfig, WidgetRegistry } from '@gspwidget/widget-devkit';
import * as NgxTranslateCore from '@ngx-translate/core';
import * as NgxTranslateHttpLoader from '@ngx-translate/http-loader';
import * as NzModalAllModule from 'ng-zorro-antd/modal';
import * as NzCoreAllModule from 'ng-zorro-antd/core';
import * as NzTooltipAllModule from 'ng-zorro-antd/tooltip';
import * as NzTableAllModule from 'ng-zorro-antd/table';
import * as CdkAllModule from '@angular/cdk'
import * as SmoothDnd from '@farris/smooth-dnd'
import { WidgetPropertyService } from './widget-property.service';

// TODO: 打包前必须换成 web path home
appendScript(`${WEB_PATH_HOME}assets/epp-amd.6.js`)
window['eppLoadScript'](`${WEB_PATH_HOME}assets/transform.js`, () => {
// appendScript(`assets/epp-amd.6.js`)
// window['eppLoadScript'](`assets/transform.js`, () => {
  const existingHook = window['System'].constructor.prototype.transform;
  window['System'].constructor.prototype.transform = function (url: string, source: string) {
    source = source.replace(/\bdefine\b/g, 'eppDefine')
    return Promise.resolve(existingHook.call(this, url, source))
  }
})

let sys
/**
 * 元部件脚本加载、初始化后得到的元部件代码元信息，非存储在数据库里的信息
 */
export interface WidgetLoadedData {
  widgetCompFactory: any
  widgetModuleFactory: any
  properties: PropertyOption[]
  propValues: {
    [propName: string]: any
  }
  widgetConfig: RegisteredWidgetConfig
}

@Injectable({ providedIn: 'root' })
export class DynamicLoaderService {

  private initSystemjsPromise: Promise<void>
  constructor (
    private injector: Injector,
    private componentFactoryResolver: ComponentFactoryResolver,
    private widgetProperty: WidgetPropertyService,
    private widgetRepo: WidgetRepo,
    ) {
    /**
     * 为了避免 ng serve 时，webpack 会把 system.import
     * 拦截为自身的实现，无法满足现在的绝对地址加载
     */
    sys = window['System']
    this.initSystemjsPromise = this.initSystemjs()
  }
  async initSystemjs () {
    sys.set('lib:@angular/common', AngularCommon)
    sys.set('lib:@angular/common/http', AngularCommonHttp)
    sys.set('lib:@angular/core', AngularCore)
    sys.set('lib:@angular/forms', AngularForms)
    sys.set('lib:@angular/platform-browser', AngularPlatformBrowser)
    sys.set('lib:@angular/platform-browser/animations', AngularPlatformBrowserAnimations)
    sys.set('lib:@angular/platform-browser-dynamic', AngularPlatformBrowserDynamic)
    sys.set('lib:@angular/router', AngularRouter)
    sys.set('lib:@angular/animations', AngularAnimations)
    sys.set('lib:@angular/animations/browser', AngularAnimationsBrowser)
    sys.set('lib:@ngx-translate/core', NgxTranslateCore)
    sys.set('lib:@ngx-translate/http-loader', NgxTranslateHttpLoader)

    // sys.set('lib:@gspwidget/portlet', PortletModule)
    // sys.set('lib:@gspwidget/widget-core', WidgetCoreModule)
    sys.set('lib:@gspwidget/widget-devkit', WidgetDevkitModule)
    sys.set('lib:@gspwidget/util', UtilModule)
    // sys.set('lib:@gspwidget/gridster', GridsterModule)
    sys.set('lib:ng-zorro-antd/modal', NzModalAllModule)
    sys.set('lib:ng-zorro-antd/core', NzCoreAllModule)
    sys.set('lib:ng-zorro-antd/tooltip', NzTooltipAllModule)
    sys.set('lib:ng-zorro-antd/table', NzTableAllModule)
    sys.set('lib:@angular/cdk', CdkAllModule)
    // 230615: 这破玩意如果有多个就会报错；
    // 本框架引入了 farris 帮助组件所以它被间接引入了，但元部件也会间接引入帮助组件从而间接它，比如日程、消息；
    // 不得已，只好使所有部件中对它的引用都用框架内的，正好还少加载些 js。
    sys.set('lib:@farris/smooth-dnd', SmoothDnd)
  }

  /**
   * 加载元部件文件，并获取 widget 的详细信息供外面用
   */
  async loadWidget (
    widgetInfo: BasicWidgetInfoAotMode | BasicWidgetInfoDevMode,
    rawPropValues: object,
    mode: WidgetContainerMode): Promise<WidgetLoadedData> {
    const { name: widgetName } = widgetInfo
    let widgetCompFactory
    let widgetModuleFactory
    switch (mode) {
      case WidgetContainerMode.AOT:
        // 加载 widget js 文件
        await this.initSystemjsPromise
        const widgetVer2 = await this.widgetRepo.getWidgetVer2()
        const systemModule = await sys.import(
          (widgetInfo as BasicWidgetInfoAotMode).href
          + '?v='
          + widgetInfo.version
          // 如果此元部件有 ver2，后面就追加上
          + (widgetVer2 && widgetVer2[widgetName]
            ? `-${widgetVer2[widgetName]}`
            : '')
          // 一次性给所有元部件都更新的
          + (widgetVer2 && widgetVer2['all']
            ? `-${widgetVer2['all']}`
            : '')
        )
        this.fixCompFacError(systemModule)
        // 加载完成后，获取 widget 的详细信息供外面用
        widgetCompFactory = getWidgetComponentFactory(widgetName, systemModule)
        widgetModuleFactory = getModuleFactoryAot(systemModule)
        break
      case WidgetContainerMode.DEV:
        widgetCompFactory = this.componentFactoryResolver.resolveComponentFactory((widgetInfo as BasicWidgetInfoDevMode).widgetComponent)
        break
    }
    const widgetConfig = WidgetRegistry.GetWidgetByName(widgetName)
    const properties = this.widgetProperty.getWidgetProps(widgetName, widgetConfig)
    const propValues = this.widgetProperty.mixinWidgetPropValues(properties, rawPropValues)
    return {
      widgetCompFactory,
      widgetModuleFactory,
      properties,
      propValues,
      widgetConfig,
    } as WidgetLoadedData
  }
  /**
   * TODO:
   * 白萌提的问题，去掉试试，拿他的元部件试试。怀疑是之前一直没传入 module 的原因。
   * 修复元部件依赖的第三方组件中 this.componentFactoryResolver.resolveComponentFactory
   * 找不到第三方组件的 ComponentFactory 的问题，
   * 如 nz RateComponent 找不到 toolTipComponent
   */
  fixCompFacError (systemModule) {
    Object.keys(systemModule)
    .filter(key => key.endsWith('ModuleNgFactory'))
    .forEach(key => {
      try {
        const { _factories } = systemModule[key].create(this.injector).componentFactoryResolver
        _factories.forEach(iFactory => {
          // @ts-ignore
          this.componentFactoryResolver._factories.set(iFactory.componentType, iFactory);
        })
      } catch (err) {}
    })
  }
}
/**
 * 
 */
function getWidgetComponentFactory (widgetName: string, systemModule: any): any {
  const componentType = WidgetRegistry.GetWidgetByName(widgetName).ctor
  if (componentType) {
    return Object.values(systemModule)
      .find((fac: any) => fac.componentType === componentType)
  }
}
function getModuleFactoryAot (systemModule: any) {
  const key = Object
    .keys(systemModule)
    .find(k => k.endsWith('ModuleNgFactory'))
  return systemModule[key] as NgModuleFactory<any>
}
